import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-with-image',
  templateUrl: './reset-password-with-image.component.html',
  styleUrls: ['./reset-password-with-image.component.scss']
})
export class ResetPasswordWithImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
